import Vue from 'vue'
import App from './App.vue'
import router from './router'

import ElementUI from 'element-ui'
import VueInsProgressBar from 'vue-ins-progress-bar'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)
import './styles/element-variables.scss'
import './styles/common.scss'
import './styles/font_sp/iconfont.css'
import './styles/icon.scss'

import * as alert from './common/alert'
import * as util from './common/util'
import * as enums from './common/enums'
import api from '@/api/api'
import VueCookies from 'vue-cookies'
import './common/filters'
import './common/directives'
import upload from '@/common/upload'

import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import VueLazyload from 'vue-lazyload'
import moment from 'moment/moment'
Vue.use(Viewer)
Viewer.setDefaults({
  Options: {
    inline: true,
    button: true,
    navbar: true,
    title: true,
    toolbar: true,
    tooltip: true,
    movable: true,
    zoomable: true,
    rotatable: true,
    scalable: true,
    transition: true,
    fullscreen: true,
    keyboard: true,
    url: 'data-source',
  },
})
Vue.use(VueCookies)
//进度条
Vue.use(VueInsProgressBar, {
  position: 'fixed',
  show: true,
  height: '3px',
})

Vue.use(VueLazyload, {
  loading: require('../src/assets/img/img-loading.gif'),
  error: require('../src/assets/img/img-error.png'),
})

Vue.config.productionTip = false
Vue.prototype.$alert = alert
Vue.prototype.$api = api
Vue.prototype.$util = util
Vue.prototype.$enum = enums
Vue.prototype.$upload = upload
Vue.prototype.$moment = moment

var _hmt = _hmt || []
window._hmt = _hmt

//统计代码获取 ai.iflysse.com 使用
;(function() {
  var hm = document.createElement('script')
  hm.src = 'https://hm.baidu.com/hm.js?7941eca614fac9f92928e9ecd9aa14e6'
  var s = document.getElementsByTagName('script')[0]
  s.parentNode.insertBefore(hm, s)
})()

window.app = new Vue({
  router,
  render: (h) => h(App),
}).$mount('#app')
console.log('main.js', window.app, Vue.prototype, Vue)
